const DAY_MS = 24 * 60 * 60 * 1000;
const DAYS_PER_MONTH = 30.44;

// PHD's project payload sends Procore dates as MM/DD/YY; every job date is this century.
export const parseMilestoneDate = (value) => {
	if (!value) return null;
	const short = /^(\d{2})\/(\d{2})\/(\d{2}|\d{4})$/.exec(value);
	if (short) {
		const year = short[3].length === 2 ? 2000 + Number(short[3]) : Number(short[3]);
		return new Date(year, Number(short[1]) - 1, Number(short[2]));
	}
	const iso = /^(\d{4})-(\d{2})-(\d{2})/.exec(value);
	if (iso) return new Date(Number(iso[1]), Number(iso[2]) - 1, Number(iso[3]));
	return null;
};

// Calendar days, immune to a DST shift between the two dates.
export const daysBetween = (from, to) =>
	Math.round((Date.UTC(to.getFullYear(), to.getMonth(), to.getDate()) - Date.UTC(from.getFullYear(), from.getMonth(), from.getDate())) / DAY_MS);

const plural = (count, word) => `${count} ${word}${count === 1 ? '' : 's'}`;

// Spelled out rather than "~5 mo": a leading tilde read as a minus sign to PMs.
const approximateMonths = (days) => (days < 60 ? '' : ` (approximately ${plural(Math.round(days / DAYS_PER_MONTH), 'month')})`);

export const describeSlip = (contractCompletion, projectedCompletion) => {
	const contract = parseMilestoneDate(contractCompletion);
	const projected = parseMilestoneDate(projectedCompletion);
	if (!contract || !projected) return null;
	const days = daysBetween(contract, projected);
	if (days === 0) return null;
	const size = Math.abs(days);
	return `Projected ${plural(size, 'day')}${approximateMonths(size)} ${days > 0 ? 'after' : 'before'} contract completion`;
};
